// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Cxe2G","field":"styles_field__1AhDO","fieldCol":"styles_fieldCol__1DhhB","diffCol":"styles_diffCol__fgPZ4","diff":"styles_diff__3ZGdc"};